export default __webpack_public_path__ + "static/media/extendedHoursScreenshot.a81c2dc9.png";